class ProductMediaSlider extends HTMLElement {
  constructor() {
    super();
    this.mediaContainer = this.querySelector('.keen-slider');
    this.variantMediaContainer = this.querySelector('.js-variant-media');
    this.sliderOptions = {
      loop: true,
    };
    this.prevButton = this.querySelector('.js-prev-button');
    this.nextButton = this.querySelector('.js-next-button');

    this.progressBars = 2;
    this.progressContainer = this.querySelector('.js-progress-track');

    this.slider = new KeenSlider(this.mediaContainer, this.sliderOptions, [
      KeenSliderWheelControls,
      this.sliderSetup.bind(this),
    ]);

    this.prevButton.addEventListener('click', () => this.slider.prev());
    this.nextButton.addEventListener('click', () => this.slider.next());
  }

  handleSliderChange(slider) {
    if (slider.slides.length <= 1) {
      this.classList.add('keen-slider--nav-hidden');
    } else {
      this.classList.remove('keen-slider--nav-hidden');
    }

    this.resetProgress(slider);
  }

  sliderSetup(slider) {
    slider.on('created', () => {
      this.classList.add('keen-slider--active');

      this.handleSliderChange(slider);
    });
    slider.on('destroyed', () => {
      this.classList.remove('keen-slider--active');
    });

    slider.on('updated', this.handleSliderChange.bind(this));

    slider.on('detailsChanged', this.updateProgress.bind(this));
  }

  updateProgress(slider) {
    const progress = slider.track.details.progress;
    let translateX = 100 * (-1 + progress);
    this.progressContainer.style.transform = `translate3d(${translateX}%, 0, 0)`;
  }

  resetProgress(slider) {
    const count = slider.track.details.slides.length;

    const width = count ? `${100 / count}%` : '0%';
    this.progressContainer.style.setProperty('--slider-progress-width', width);
    this.updateProgress(slider);
  }

  removeProgress() {
    if (this.progressContainer) {
      this.progressContainer.style.display = 'none';
    }
  }

  setActiveVariantMedia(variantId, prepend) {
    this.mediaContainer.querySelectorAll('[data-media-id]').forEach((element) => {
      element.classList.remove('is-active');
    });
    this.mediaContainer.querySelectorAll('.product__media-item--variant').forEach((variantMedia) => {
      this.variantMediaContainer.appendChild(variantMedia);
    });
    let variantMedia = this.mediaContainer.querySelectorAll(`[data-variant-id="${variantId}"]`);
    if (!variantMedia.length) {
      variantMedia = this.variantMediaContainer.querySelectorAll(`[data-variant-id="${variantId}"]`);
      if (variantMedia.length) {
        Array.from(variantMedia)
          .reverse()
          .forEach((media) => {
            if (prepend) {
              this.mediaContainer.prepend(media);
            } else {
              this.mediaContainer.appendChild(media);
            }
          });
      }
    }
    const activeMedia = variantMedia[0];
    if (!activeMedia) {
      return;
    }
    activeMedia.classList.add('is-active');

    if (prepend) {
      activeMedia.parentElement.prepend(activeMedia);
      this.slider.update({
        ...this.sliderOptions,
      });
      this.slider.update();
    }

    const activeIndex = this.slider.slides.indexOf(activeMedia);
    if (activeIndex !== -1) {
      this.slider.moveToIdx(activeIndex);
    }
  }

  setActiveMedia(mediaId, prepend) {
    this.mediaContainer.querySelectorAll('[data-media-id]').forEach((element) => {
      element.classList.remove('is-active');
    });
    this.mediaContainer.querySelectorAll('.product__media-item--variant').forEach((variantMedia) => {
      this.variantMediaContainer.appendChild(variantMedia);
    });
    let activeMedia = this.mediaContainer.querySelector(`[data-media-id="${mediaId}"]`);
    if (!activeMedia) {
      activeMedia = this.variantMediaContainer.querySelector(`[data-media-id="${mediaId}"]`);
      if (activeMedia) {
        this.mediaContainer.appendChild(activeMedia);
      }
    }
    if (!activeMedia) {
      return;
    }
    activeMedia.classList.add('is-active');

    if (prepend) {
      activeMedia.parentElement.prepend(activeMedia);
      this.slider.update({
        ...this.sliderOptions,
      });
      this.slider.update();
    }

    const activeIndex = this.slider.slides.indexOf(activeMedia);
    if (activeIndex !== -1) {
      this.slider.moveToIdx(activeIndex);
    }
  }
}

customElements.define('product-media-slider', ProductMediaSlider);
